import LoadedRoute from 'src/components/common/loaded-route';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import getDisplayName from 'src/utils/get-display-name';
import hoistNonReactStatics from 'hoist-non-react-statics';

import { action } from 'mobx';
import { inject, observer } from 'mobx-react';

const withModelIds = {};

let id = 0;

export default function withModel(WrappedComponent) {
  const withModelId = WrappedComponent.componentId
    ? WrappedComponent.componentId
    : `withModel${id}`;

  id += 1;

  if (withModelIds[withModelId]) {
    throw new Error(
      `Component with id already registered using withModel(): ${withModelId}`
    );
  }
  @inject('router')
  @observer
  class WithModel extends Component {
    static propTypes = {
      router: PropTypes.object.isRequired,
      model: PropTypes.object,
    };

    render() {
      const model =
        this.props.model ||
        (this.props.router.route &&
          this.props.router.modelsById.get(withModelId));
      const props = {
        ...this.props,
        model,
      };
      return model !== undefined ? (
        <React.Fragment>
          <WrappedComponent {...props} />
          <LoadedRoute />
        </React.Fragment>
      ) : null;
    }
  }

  hoistNonReactStatics(WithModel, WrappedComponent);
  WithModel.withModelId = withModelId;
  WithModel.model = action(WithModel.model);
  WithModel.displayName = `WithModel(${getDisplayName(WrappedComponent)})`;
  return WithModel;
}
